// tslint:disable
export enum CampaignMemberType {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description PATIENT
     */
    PAT = 10002,
    /**
     * @description PRESCRIBER/HCP/PROVIDER
     */
    PRE = 10003,
    /**
     * @description SITE
     */
    SITE = 10004,
    /**
     * @description PHARMACY
     */
    PHA = 10005,
    /**
     * @description PHARMACIST
     */
    PHAT = 10006,
    /**
     * @description PAYOR
     */
    PAY = 10007,
    /**
     * @description PHARMA SALES REPRESENTATIVE
     */
    PHASR = 10008,
    /**
     * @description OTHERS
     */
    OTH = 10009,
    /**
     * @description LASH BI
     */
    LBI = 10010,
    /**
     * @description PROSPECT
     */
    PROS = 10011,
    /**
     * @description Custom
     */
    CUS = 10012,
}
